module.exports = __webpack_public_path__ + "static/showreel_2024-056a94c8027deb42df16a69b8af484c1.mp4";